import axios from "axios";
import { getOptions } from "../../helpers/api";

export const tracking = {
  getUserLocationTracking: (data) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/UserTracking/getUserLocationTracking`, {...data, username: data.usernames}, headers);
  }, 
  
  getInspectors: (data) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/UserTracking/get-inspectors?Municipality=${data.Municipality || ""}`, headers);
  },

  getUserSummaryTracking: (data) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/UserTracking/Summary`, {...data, username: data.usernames}, headers);
  },
};
